import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Prodect_1 from '../../../assets/images/home_page_4/deals/01.png'
import Prodect_2 from '../../../assets/images/home_page_4/product/17.png'
import Prodect_3 from '../../../assets/images/home_page_4/product/04.png'
import Prodect_4 from '../../../assets/images/home_page_4/product/13.png'
import Prodect_5 from '../../../assets/images/home_page_4/product/14.png'
import Prodect_6 from '../../../assets/images/home_page_4/product/05.png'
import Prodect_7 from '../../../assets/images/home_page_4/product/09.png'
import Prodect_8 from '../../../assets/images/home_page_4/deals/02.png'
import Prodect_9 from '../../../assets/images/home_page_4/deals/03.png'
import Prodect_10 from '../../../assets/images/home_page_4/deals/04.png'
import Prodect_11 from '../../../assets/images/home_page_4/deals/05.png'
import Prodect_12 from '../../../assets/images/home_page_4/deals/06.png'
import Slider from 'react-slick'

const sattings = {
    slidesToShow: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}

const sattings2 = {
    slidesToShow: 5,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            }
        }
    ]
}


const Prodect = () => {
    const [activeTab, setActiveTab] = useState('pills-grid');
    const [isSortDropdownOpen, setSortDropdownOpen] = useState(false);
    const [isItemsDropdownOpen, setItemsDropdownOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);


    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef(null);
    const slider2 = useRef(null);

    const [quantity, setQuantity] = useState(1);

    const handleDecrement = () => {
        if (quantity > 0) setQuantity(quantity - 1);
    };

    const handleIncrement = () => {
        if (quantity < 100) setQuantity(quantity + 1);
    };

    const handleChange = (e) => {
        const value = Math.max(0, Math.min(10, e.target.value));
        setQuantity(value);
    };

    


    return (
        <>
            <section id="shop-filter" className="shop-filter-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-4 col-md-12">
                            <div className="shop-filter-result">
                                <h3 className="shop-filter-result-title">Showing Result:</h3>
                                <p>1-8 Out of 38</p>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-8 col-md-12">
                            <div className="row">

                                <div className="col-lg-5 col-md-5">
                                    <div className="shop-filter-sort-block float-start float-lg-end">
                                        <h3 className="shop-filter-sort-title">Sort by</h3>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-secondary dropdown-toggle"
                                                type="button"
                                                onClick={() => setSortDropdownOpen(!isSortDropdownOpen)}
                                                aria-expanded={isSortDropdownOpen}
                                            >
                                                Default <i className="flaticon-down-arrow" />
                                            </button>
                                            <ul className={`dropdown-menu ${isSortDropdownOpen ? "show" : ""}`}>
                                                <li><Link className="dropdown-item" to="#">Action</Link></li>
                                                <li><Link className="dropdown-item" to="#">Another action</Link></li>
                                                <li><Link className="dropdown-item" to="#">Something else here</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4">
                                    <div className="shop-filter-sort-block float-start float-lg-end">
                                        <h3 className="shop-filter-sort-title">Items</h3>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-secondary dropdown-toggle"
                                                type="button"
                                                onClick={() => setItemsDropdownOpen(!isItemsDropdownOpen)}
                                                aria-expanded={isItemsDropdownOpen}
                                            >
                                                10 <i className="flaticon-down-arrow" />
                                            </button>
                                            <ul className={`dropdown-menu ${isItemsDropdownOpen ? "show" : ""}`}>
                                                <li><Link className="dropdown-item" to="#">10</Link></li>
                                                <li><Link className="dropdown-item" to="#">100</Link></li>
                                                <li><Link className="dropdown-item" to="#">1000</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>


                                <div className="col-lg-3 col-md-3">
                                    <div className="list-grid-filter float-start float-lg-end">
                                        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <Link className={`nav-link ${activeTab === 'pills-grid' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('pills-grid')} id="pills-grid-tab" data-bs-toggle="pill" to="#pills-grid" role="tab" aria-controls="pills-grid" aria-selected="true">
                                                    <i className="flaticon-dots" />
                                                </Link>
                                            </li>
                                            <li className="nav-item" role="presentation">
                                                <Link className={`nav-link ${activeTab === 'pills-list' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('pills-list')} id="pills-list-tab"
                                                    data-bs-toggle="pill" to="#pills-list" role="tab" aria-controls="pills-list" aria-selected="false">
                                                    <i className="flaticon-hamburger" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="shop" className="shop-main-block">
                <div className="container">
                    <div className="tab-content" id="pills-tabContent">
                        <div className={`tab-pane fade ${activeTab === 'pills-grid' ? 'show active' : ''}`} id="#pills-grid"
                            role="tabpanel"
                            aria-labelledby="pills-grid-tab"

                        >
                            <div className="row">
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <button
                                                className="btn"
                                                onClick={() => setShowModal(true)}
                                            >
                                                <img src={Prodect_1} className="img-fluid" alt="Product" />
                                            </button>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>199.99</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_8} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_11} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_12} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_8} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_11} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_12} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_1} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_11} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_1} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_8} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_11} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_12} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_8} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_8} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_1} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_8} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_12} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_1} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_9} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_10} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-3 col-md-4">
                                    <div className="deals-product-block">
                                        <div className="deals-product-img text-center">
                                            <Link
                                                to="#"
                                                title=""
                                                data-bs-toggle="modal"
                                                data-bs-target=".dealsproductModal"
                                            >
                                                <img
                                                    src={Prodect_11} onClick={() => setShowModal(true)}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                        <div className="deals-product-dtls">
                                            <h6 className="deals-product-heading">
                                                <Link to="/ShopDetails" title="">
                                                    Sony A7 III Mirrorless Camera with 4K Video
                                                </Link>
                                            </h6>
                                            <div className="price">
                                                $159.77 <s>$</s>
                                                <s>159.77</s>
                                            </div>
                                            <div className="deals-product-btn">
                                                <button type="button" className="btn btn-primary">
                                                    <i className="flaticon-shopping-cart" />
                                                    Add to cart
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {showModal && (
                            <div className="modal-overlay">
                                <div
                                    className="modal fade dealsproductModal show"
                                    tabIndex={-1}
                                    aria-labelledby="exampleModalLabel"
                                    style={{ display: "block", paddingLeft: 0 }}
                                    aria-modal="true"
                                    role="dialog"
                                >
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={() => setShowModal(false)}
                                                />
                                            </div>
                                            <div className="modal-body">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <Slider className="shop-slider-for" {...sattings} asNavFor={nav2}
                                                        ref={(slider) => setNav1(slider)}>
                                                            <img src={Prodect_2} className="img-fluid" alt="Product" />
                                                            <img src={Prodect_3} className="img-fluid" alt="Product" />
                                                            <img src={Prodect_4} className="img-fluid" alt="Product" />
                                                            <img src={Prodect_5} className="img-fluid" alt="Product" />

                                                        </Slider>
                                                        <Slider className="shop-slider-nav d-flex"{...sattings2} asNavFor={nav1}
                                                            ref={(slider) => setNav2(slider)} focusOnSelect={true}>
                                                            <img src={Prodect_3} className="img-thumbnail" alt="Product" />
                                                            <img src={Prodect_4} className="img-thumbnail" alt="Product" />
                                                            <img src={Prodect_5} className="img-thumbnail" alt="Product" />
                                                        </Slider>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="product-detail-block">
                                                            <h2 className="product-dtl-title">Powering Your Mobile Experience</h2>
                                                            <p>
                                                                Web designing in a powerful way of just not an only professi however, in a
                                                                pass Company We have a to a tendency
                                                            </p>
                                                            <ul className="d-flex product-star-rating">
                                                                <li className="icons">
                                                                    <i className="flaticon-star star-yellow" />
                                                                </li>
                                                                <li className="icons">
                                                                    <i className="flaticon-star star-yellow" />
                                                                </li>
                                                                <li className="icons">
                                                                    <i className="flaticon-star star-yellow" />
                                                                </li>
                                                                <li className="icons">
                                                                    <i className="flaticon-star star-yellow" />
                                                                </li>
                                                                <li className="icons">
                                                                    <i className="flaticon-star star-grey" />
                                                                </li>
                                                            </ul>
                                                            <div className="cust-rat-review">1 Customer Review</div>
                                                            <div className="price">
                                                                $32.00 <s>$</s>
                                                                <s>25.00</s>
                                                            </div>
                                                            <ul className="product-dtl-list">
                                                                <li>6.4Inch display toch sceen (1920x1180)</li>
                                                                <li>6000Mh Battry With Fast Chager</li>
                                                            </ul>
                                                            <div className="qty-input">
                                                                <button
                                                                    className="qty-count qty-count--minus"
                                                                    data-action="minus"
                                                                    onClick={handleDecrement}
                                                                    type="button"
                                                                >
                                                                    -
                                                                </button>
                                                                <input
                                                                    className="product-qty"
                                                                    type="number"
                                                                    name="product-qty"
                                                                    min={0}
                                                                    max={10}
                                                                    value={quantity}  // Controlled value
                                                                    onChange={handleChange}
                                                                />
                                                                <button
                                                                    className="qty-count qty-count--add"
                                                                    data-action="add"
                                                                    onClick={handleIncrement}
                                                                    type="button"
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                            <div className="product-dtl-cart-btn">
                                                                <button type="button" className="btn btn-primary">
                                                                    Add to cart
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div
                            className={`tab-pane fade ${activeTab === 'pills-list' ? 'show active' : ''}`}
                            id="#pills-list"
                            role="tabpanel"
                            aria-labelledby="pills-list-tab"

                        >
                            <div className="table-responsive">
                                <table className="table deals-product-block list-deals-product-block">
                                    <tbody>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_1}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_11}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_12}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_11}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_12}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_1}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_1}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_11}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_12}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_1}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_8}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_12}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_1}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_9}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_10}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="deals-product-dtls">
                                            <th width="30%">
                                                <div className="deals-product-img text-center">
                                                    <Link to="/ShopDetails" title="">
                                                        <img
                                                            src={Prodect_11}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                    </Link>
                                                </div>
                                            </th>
                                            <td>
                                                <h6 className="deals-product-heading">
                                                    <Link to="/ShopDetails" title="">
                                                        Sony A7 III Mirrorless Camera with 4K Video
                                                    </Link>
                                                </h6>
                                            </td>
                                            <td>
                                                <div className="price">
                                                    $159.77 <s>$</s>
                                                    <s>159.77</s>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="deals-product-btn">
                                                    <button type="button" className="btn btn-primary">
                                                        <i className="flaticon-shopping-cart" />
                                                        Add to cart
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Prodect
